import { Entidad } from "../../../data/Entidad";
import { _DICC_METODO_PAGO } from "../../../data/modulo/FinanzaMetodoPago";
import _L from "../../../util/Labels";
import { UIUtilFormat } from "../../util/Format";

import CCategoriaMov = Entidad.CFinanzaCategoriaMovimiento;

type IMovimiento = Entidad.IFinanzaMovimientoV2;
type IMetodoPago = Entidad.IFinanzaMetodoPago;



export namespace AlumnoEdoCtaUtil {

    export interface IMovimientoTbl extends Entidad.IFinanzaMovimientoV2 {
        Periodo?: string;
        /** Solo para configuración de tabla */
        PagoAbono?: string;
        /** Solo para configuración de tabla */
        FechaPago?: string;
        /** Solo para configuración de tabla */
        MetodoPago?: string;
    }

    export interface ICurrentData {
        IdAlumno: number;
        AlumnoNombre: string;
        NoCuenta: string;
        Tutoes: string[];
        StrNivel: string;

        StrPeriodo: string;
        SaldoPeriodo: number;
        SaldoPendiente: number;
        InteresesGenerados: number;
        TotalPago: number;
        MovimientosPeriodo: IMovimientoTbl[];

        MovimientosTbl_TopPeriodo: IMovimientoTbl[];
    }

    export const MODULO_PERMISO = Entidad.CModulo.PanelFinanzasEdoCuenta;
    export const MODULO_LANG_KEY = Entidad.CModulo[Entidad.CModulo.PanelFinanzasEdoCuenta].toLowerCase();

    export function GetSaldoMovimiento(mov: Pick<IMovimientoTbl, "Saldo" | "Detalles">): number {
        let saldo = mov.Saldo;

        if (mov.Detalles?.length) {
            saldo = mov.Detalles[mov.Detalles.length - 1].Saldo;
        }

        return saldo;
    }

    export function GetMetodosPagoList(idEscuela: number): IMetodoPago[] {
        return Array.from(_DICC_METODO_PAGO.values())
            .filter(d => (d.IdEscuela == idEscuela && d.ProveedorElectronico == Entidad.CProveedorMetodoPagoElectronico.SinProveedor));
    }

    /** Recargo pendiente por pagar */
    export function GetAdeudoRecargoFromCargo(mov: Pick<IMovimientoTbl, "Detalles">): number {
        let totalRecargos = 0;
        if (mov.Detalles && mov.Detalles.length > 0) {
            mov.Detalles
                .filter((d, i) => (
                    d.Categoria == CCategoriaMov.Morosidad
                    && d.IdMetodoPago == 0
                    && (!mov.Detalles[i + 1] || ![CCategoriaMov.PagoParcial, CCategoriaMov.PagoCompleto].includes(mov.Detalles[i + 1].Categoria))
                ))
                .forEach(d => totalRecargos += d.Recargo);
        }
        return totalRecargos;
    }

    export function GetPagoValidation(inputPago: number, cargo: Pick<IMovimientoTbl, "Saldo" | "Detalles">) {
        type TFix = ("maxpay" | "minrecargo");
        const saldo = GetSaldoMovimiento(cargo);
        let decimales = (String(inputPago).split("."))[1];
        let decimalesValidos = (decimales ? (decimales.length > 0 && decimales.length < 3) : true);
        // let isValid = true;
        let message: string;
        let typeFix: TFix = "maxpay";

        if (inputPago <= 0) {
            message = _L("panelfinanzasedocuenta.notif_pagoinvalido")
                .replace("_VALOR", UIUtilFormat._CurrencyFmt(inputPago));
        }
        else if (inputPago < GetAdeudoRecargoFromCargo(cargo)) {
            message = _L("panelfinanzasedocuenta.notif_pagominrecargo");
            typeFix = "minrecargo";
        }
        else if (inputPago > saldo) {
            message = _L("panelfinanzasedocuenta.notif_pagoexcede");
        }
        else if (!decimalesValidos) {
            message = _L("panelfinanzasedocuenta.notif_cantsinvalid");
        }

        return {
            IsValid: (message == null),
            Message: message,
            TypeFix: typeFix
        }
    }
}